import { Pipe, PipeTransform } from '@angular/core';
import {
  ContainerItemOption,
  ContainerModel,
} from '@app/models/server/layout.model';
import { from, Observable, of } from 'rxjs';

@Pipe({
  name: 'availableHours',
  standalone: true,
})
export class AvailableHoursPipe implements PipeTransform {
  transform(
    availableHours: ContainerItemOption[],
    nextAvailableCheckInTimeCard: ContainerModel,
    nextAvailableHourCard: ContainerModel,
    selectedCheckInTimeOption: ContainerItemOption,
  ): Observable<ContainerModel> {
    if (selectedCheckInTimeOption) {
      return from(
        this.createAvailableHours(
          nextAvailableCheckInTimeCard?.options,
          nextAvailableHourCard?.options,
          nextAvailableHourCard?.productCheckInHour,
          nextAvailableHourCard?.productCheckOutHour,
          nextAvailableHourCard?.isSameDayCheckout,
          selectedCheckInTimeOption,
        ),
      );
    } else {
      return of({
        options: nextAvailableHourCard?.options,
      });
    }
  }

  async createAvailableHours(
    checkinTimeOptions: ContainerItemOption[],
    activeHourOptionsData: ContainerItemOption[],
    productCheckInHour: number,
    productCheckOutHour: number,
    isSameDayCheckout: boolean,
    selectedCheckInTimeOption: ContainerItemOption,
  ): Promise<ContainerModel> {
    const m = await import(
      '@app/services/util-services/lazy-functions/create-next-available-hour.util'
    );

    return m.createNextAvailableHourCard(
      checkinTimeOptions,
      activeHourOptionsData,
      productCheckInHour,
      productCheckOutHour,
      isSameDayCheckout,
      selectedCheckInTimeOption,
    );
  }
}
